import axios from 'axios';
import { GET_CASES_ENDPOINT } from '../constants/endpoint';

const ListCases = async prospectId => {
  const response = await axios.get(`${GET_CASES_ENDPOINT}/${prospectId}`);
  return response;
};

export { ListCases };
